'use client';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { Dropdown } from 'react-bootstrap';

const validationSchema = Yup.object().shape({
  permissionValue: Yup.string().required('Permission value is required'),
  permissionDisplayName: Yup.string().required('Name is required'),
  permissionTypeId: Yup.string().required('Permission type is required'),
  moduleId: Yup.string().required('Module is required'),
});

const AddUiPermissionsForm = ({
  handleCloseAddForm,
  handleFormSubmit,
  uiPermissionData,
  permissionType,
  open,
  permissionModule,
  permissionParent,
}) => {
  const [formData, setFormData] = useState(uiPermissionData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [filteredPermissionParent, setFilteredPermissionParent] = useState([]);

  useEffect(() => {
    if (!formData?.permissionTypeId) {
      const activePermissionType = permissionType?.find(
        (permissionType) => permissionType.displayName === 'Menu'
      );
      if (activePermissionType) {
        setFormData({
          ...formData,
          permissionTypeId: activePermissionType.id,
          permissionTypeName: activePermissionType.displayName,
        });
      }
    }
  }, [permissionType]);

  useEffect(() => {
    if (formData?.permissionTypeName === 'Menu') {
      // setFilteredPermissionParent([]);
      const filteredParents = permissionParent.filter(
        (parent) =>
          parent.permissionDisplayName.toLowerCase().includes('menu') &&
          parent.moduleId === formData.moduleId &&
          parent.permissionParentId === null
      );
      setFilteredPermissionParent(filteredParents);
    } else if (formData?.permissionTypeName === 'Screen') {
      let filteredParents = permissionParent.filter(
        (parent) =>
          parent.permissionDisplayName.toLowerCase().includes('menu') &&
          parent.moduleId === formData.moduleId
      );
      if (filteredParents.length > 1) {
        filteredParents = filteredParents.filter((parent) => parent.permissionParentId !== null);
      }
      setFilteredPermissionParent(filteredParents);
    } else if (formData?.permissionTypeName === 'Field') {
      const filteredParents = permissionParent.filter(
        (parent) =>
          parent.permissionDisplayName.toLowerCase().includes('screen') &&
          parent.moduleId === formData.moduleId
      );
      setFilteredPermissionParent(filteredParents);
    }
  }, [formData?.permissionTypeName, permissionParent]);

  const handleDropdownChange = (selectedId, e, name) => {
    const selectedValue = e.currentTarget.textContent;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'permissionTypeId') {
      const updatedFormData = {
        ...formData,
        permissionTypeId: selectedId,
        permissionTypeName: selectedValue,
      };
      if (formData.type === 'add') {
        updatedFormData.permissionParentId = '';
        updatedFormData.permissionParentName = '';
      }
      setFormData(updatedFormData);
    } else if (name === 'permissionParentId') {
      setFormData({
        ...formData,
        permissionParentId: selectedId,
        permissionParentName: selectedValue,
      });
    } else if (name === 'moduleId') {
      const updatedFormData = {
        ...formData,
        moduleId: selectedId,
        moduleName: selectedValue,
      };
      if (formData.type === 'add') {
        updatedFormData.permissionTypeId = '';
        updatedFormData.permissionParentId = '';
        updatedFormData.permissionTypeName = '';
        updatedFormData.permissionParentName = '';
      }
      setFormData(updatedFormData);
    } else if (name === 'permissionValueId') {
      setFormData({
        ...formData,
        permissionValueId: selectedId,
        permissionValueName: selectedValue,
        permissionTypeName: '',
      });
    } else {
      setFormData({
        ...formData,
        [name]: selectedId,
        [`${name}Name`]: selectedValue,
      });
    }
    setFormEdited(true);
  };

  const handleChangeForm = (e) => {
    const { name, value, checked, type } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    // Update form data based on input type
    const newValue = type === 'checkbox' ? checked : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setFormEdited(true);
  };

  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      if (uiPermissionData && uiPermissionData.type === 'edit') {
        handleFormSubmit(formData);
      } else {
        handleFormSubmit(formData);
      }
    } catch (error) {
      const fieldErrors = {};
      error.inner?.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const [isExpand, setIsExpand] = useState(false);

  const handleExpand = () => {
    setIsExpand((prev) => !prev);
  };

  return (
    <>
      <div className={isExpand ? 'modal-dialog maxContent' : 'modal-dialog defaultContent'}>
        <div className="modal-content" style={{ minHeight: '300px', maxHeight: '500px' }}>
          <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
            <h5> {formData?.type === 'add' ? 'Add Ui Permission' : 'Update Ui Permission'}</h5>
            <div className="modalHdrRight">
              <button onClick={handleExpand} className={isExpand ? 'maxBtn me-4' : 'minBtn me-4'}>
                <div
                  className={isExpand ? 'maxBtnsvg' : ''}
                  style={{ display: isExpand ? 'block' : 'none' }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16.558"
                    height="16.558"
                    viewBox="0 0 16.558 16.558"
                  >
                    <path
                      id="minimize"
                      d="M3.763,11.391H8.339m0,0v4.577m0-4.577L3,16.73M15.967,8.339H11.391m0,0V3.763m0,4.577L16.73,3"
                      transform="translate(-1.586 -1.586)"
                      fill="none"
                      stroke="#333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
                <div
                  className={!isExpand ? 'minBtnsvg' : ''}
                  style={{
                    display: !isExpand ? 'block' : 'none',
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16.561"
                    height="16.561"
                    viewBox="0 0 16.561 16.561"
                  >
                    <path
                      id="maximize"
                      d="M11.392,8.341,16.733,3m0,0H12.155m4.578,0V7.578M8.341,11.392,3,16.733m0,0H7.578M3,16.733V12.155"
                      transform="translate(-1.586 -1.586)"
                      fill="none"
                      stroke="#333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </button>

              <button
                type="button"
                className="custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseAddForm}
              ></button>
            </div>
          </div>
          <div className="modal-body" style={{ overflow: 'visible' }}>
            <Formik
              initialValues={formData}
              onSubmit={(values) => handleSubmit(values)}
              validationSchema={validationSchema}
            >
              <Form>
                <div className="row">
                  <>
                    <div className="col-12 col-md-6">
                      <div className="input-container form_border">
                        <label htmlFor="moduleId">
                          UI Module<span className="required-star">*</span>
                        </label>

                        <Dropdown
                          onSelect={(val, e) => handleDropdownChange(val, e, 'moduleId')}
                          className={`formik-input ${formData?.type === 'edit' ? 'disabled' : ''}`}
                        >
                          <Dropdown.Toggle
                            variant="success"
                            name="moduleId"
                            id="dropdown-basic"
                            disabled={formData?.type === 'edit' ? true : false}
                          >
                            {formData?.moduleName || 'Select Module'}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {permissionModule?.map((data) => (
                              <Dropdown.Item
                                key={data.id}
                                // value={data.value}
                                eventKey={data.id}
                              >
                                {data.displayName}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                        {errormsg.moduleId && (
                          <div className="error-message">{errormsg.moduleId}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-container form_border">
                        <label htmlFor="firstName">
                          UI Permission Type<span className="required-star">*</span>
                        </label>

                        <Dropdown
                          onSelect={(val, e) => handleDropdownChange(val, e, 'permissionTypeId')}
                          className={`formik-input ${formData?.type === 'edit' ? 'disabled' : ''}`}
                        >
                          <Dropdown.Toggle
                            variant="success"
                            name="permissionTypeId"
                            id="dropdown-basic"
                            disabled={formData?.type === 'edit' ? true : false}
                          >
                            {formData?.permissionTypeName || 'Select Permission type'}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {permissionType?.map((data) => (
                              <Dropdown.Item key={data.id} eventKey={data.id}>
                                {data.displayName}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                        {errormsg.permissionTypeId && (
                          <div className="error-message">{errormsg.permissionTypeId}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-container form_border">
                        <label htmlFor="firstName">UI Permission Parent</label>

                        <Dropdown
                          onSelect={(val, e) => handleDropdownChange(val, e, 'permissionParentId')}
                          className={`formik-input ${formData?.type === 'edit' ? 'disabled' : ''}`}
                        >
                          <Dropdown.Toggle
                            variant="success"
                            name="permissionParentId"
                            id="dropdown-basic"
                            disabled={formData?.type === 'edit' ? true : false}
                          >
                            {formData?.permissionParentName || 'Select Permission parent'}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filteredPermissionParent.map((data) => (
                              <Dropdown.Item key={data.permissionId} eventKey={data.permissionId}>
                                {data.permissionDisplayName}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-container">
                        <label htmlFor="firstName">
                          UI Permission Values<span className="required-star">*</span>
                        </label>

                        <Field
                          className={`formik-input ${formData?.type === 'edit' ? 'disabled' : ''}`} // Add the disabled class conditionally
                          required
                          type="text"
                          name="permissionValue"
                          id="permissionValue"
                          variant="outlined"
                          value={formData?.permissionValue}
                          onChange={handleChangeForm}
                          disabled={formData?.type === 'edit' ? true : false}
                        />
                        {errormsg.permissionValue && (
                          <div className="error-message">{errormsg.permissionValue}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-container">
                        <label htmlFor="firstName">
                          UI Permission Name<span className="required-star">*</span>
                        </label>
                        <Field
                          className="formik-input"
                          required
                          type="text"
                          name="permissionDisplayName"
                          id="permissionDisplayName"
                          variant="outlined"
                          value={formData?.permissionDisplayName}
                          onChange={handleChangeForm}
                        />
                        {errormsg.permissionDisplayName && (
                          <div className="error-message">{errormsg.permissionDisplayName}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className="input-container2" style={{ paddingTop: '3rem' }}>
                        <label htmlFor="isActive">Active</label>
                        <Field
                          type="checkbox"
                          name="isActive"
                          checked={formData?.isActive}
                          onChange={handleChangeForm}
                          disabled={formData?.type === 'add' ? true : false}
                        />
                      </div>
                    </div>
                  </>
                </div>
              </Form>
            </Formik>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseAddForm}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit(formData);
              }}
              disabled={formData?.type === 'edit' && !formEdited}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUiPermissionsForm;
